// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__zmrB7","widget":"styles_widget__OYjYF","overlay":"styles_overlay__acXOH","copyWrapper":"styles_copyWrapper__40BJL"};